// @file phoenix socket setup
import { captureException } from '@@/bits/error_tracker'
import * as Phoenix from 'phoenix'

export function getSocket(
  {
    accessToken,
    deviceId,
    shouldUseLongPoll,
  }: { accessToken: string; deviceId?: string | undefined | null; shouldUseLongPoll?: boolean | undefined | null },
  reconnectAfterMs?: ((tries: number) => number) | undefined,
): Phoenix.Socket | undefined {
  try {
    const realtimeTag = document.getElementsByName('realtime-uri')[0] as HTMLMetaElement
    const socket = new Phoenix.Socket(realtimeTag.content, {
      params: { accessToken, deviceId },
      reconnectAfterMs,
      transport: shouldUseLongPoll ?? false ? Phoenix.LongPoll : undefined,
    })

    return socket
  } catch (e) {
    captureException(e)
  }

  return undefined
}
